import * as Headless from '@headlessui/react';
import React, { forwardRef } from 'react';

/**
 * Link component that renders an anchor element wrapped in a Headless UI DataInteractive component.
 * This component can be used to create links that integrate with client-side routing frameworks.
 * @param {Object} props - The properties passed to the anchor element.
 * @param {React.Ref} ref - The ref forwarded to the anchor element.
 * @returns {JSX.Element} The rendered link component.
 */
export const Link = forwardRef(function Link(props, ref) {
  return (
    <Headless.DataInteractive>
      <a {...props} ref={ref}>
        {props.children || (
          <span className="sr-only">{props['aria-label']}</span>
        )}
      </a>
    </Headless.DataInteractive>
  );
});
